var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9405 1.45313H38.0595C40.2366 1.45313 42.3245 2.31796 43.8639 3.85737C45.4033 5.39679 46.2681 7.48468 46.2681 9.66174L50 41.381C49.9993 43.5577 49.134 45.645 47.5945 47.1838C46.055 48.7226 43.9674 49.587 41.7907 49.5868H8.20862C6.03203 49.5868 3.94456 48.7224 2.40522 47.1836C0.865886 45.6447 0.000730152 43.5576 0 41.381L3.73119 9.66174C3.73119 8.58371 3.94353 7.51624 4.3561 6.52028C4.76866 5.52432 5.37337 4.61938 6.13568 3.85713C6.89799 3.09488 7.80299 2.49025 8.79898 2.07777C9.79498 1.66529 10.8625 1.45303 11.9405 1.45313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9405 3.51836C10.3117 3.52018 8.75006 4.16799 7.59824 5.31968C6.44641 6.47138 5.79843 8.03291 5.79642 9.66174V9.7829L2.06523 41.4904C2.09657 43.0995 2.7573 44.6322 3.90567 45.7597C5.05403 46.8872 6.59857 47.5198 8.20793 47.5216H41.7907C43.4001 47.5198 44.9446 46.8872 46.093 45.7597C47.2413 44.6322 47.9021 43.0995 47.9334 41.4904L44.2029 9.7829V9.66174C44.2009 8.03303 43.553 6.4716 42.4013 5.31993C41.2496 4.16825 39.6882 3.52036 38.0595 3.51836H11.9405ZM11.9405 1.45313H38.0595C40.2366 1.45313 42.3245 2.31796 43.8639 3.85737C45.4033 5.39679 46.2681 7.48468 46.2681 9.66174L50 41.381C49.9993 43.5577 49.134 45.645 47.5945 47.1838C46.055 48.7226 43.9674 49.587 41.7907 49.5868H8.20862C6.03203 49.5868 3.94456 48.7224 2.40522 47.1836C0.865886 45.6447 0.000730152 43.5576 0 41.381L3.73119 9.66174C3.73119 8.58371 3.94353 7.51624 4.3561 6.52028C4.76866 5.52432 5.37337 4.61938 6.13568 3.85713C6.89799 3.09488 7.80299 2.49025 8.79898 2.07777C9.79498 1.66529 10.8625 1.45303 11.9405 1.45313Z",
    fill: "#2B1C50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.326 35.502H15.3621V15.5381H35.326V35.502Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0504 16.2264V34.8135H34.6375V16.2264H16.0504ZM15.362 14.8496H35.3259C35.7061 14.8496 36.0143 15.1578 36.0143 15.538V35.5019C36.0143 35.8821 35.7061 36.1904 35.3259 36.1904H15.362C14.9818 36.1904 14.6736 35.8821 14.6736 35.5019V15.538C14.6736 15.1578 14.9818 14.8496 15.362 14.8496Z",
    fill: "#2B1C50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.949 38.9441H16.7388C15.218 38.9441 13.9851 40.1769 13.9851 41.6977C13.9851 43.2185 15.218 44.4514 16.7388 44.4514H33.949C35.4698 44.4514 36.7027 43.2185 36.7027 41.6977C36.7027 40.1769 35.4698 38.9441 33.949 38.9441Z",
    fill: "#2B1C50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1828 23.779H18.4734V19.0703H23.1828V23.779ZM19.526 20.116V22.7258H22.1344V20.1167L19.526 20.116Z",
    fill: "#565ADD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1907 19.0654H31.8995V23.7742H27.1907V19.0654ZM28.2371 22.7257H30.8462V20.1166H28.2371V22.7257Z",
    fill: "#565ADD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4756 27.7808H23.1843V32.4895H18.4756V27.7808ZM19.5261 28.8306V31.4397H22.1345V28.8306H19.5261Z",
    fill: "#565ADD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1835 21.687H26.2257V23.7811H25.1828V25.7555L25.1869 25.7521H24.1316L24.1357 25.7555V22.7403H25.1862V21.6829L25.1835 21.687Z",
    fill: "#565ADD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0894 25.7555H22.1378V24.7104H23.1849V25.7555H24.1383L24.1342 25.752V26.806L24.1377 26.8018H21.0928V25.752L21.0894 25.7555Z",
    fill: "#565ADD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8537 26.8067H31.8967V29.349H29.3833L29.3867 29.3531V28.2964H30.8565V26.8032L30.8537 26.8067Z",
    fill: "#565ADD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0934 25.7519H19.5197V26.7955H18.4768V24.7124H21.0928V25.7546L21.0934 25.7519Z",
    fill: "#565ADD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2865 29.3482H25.1848L25.1882 29.3516C25.1882 29.0005 25.1882 28.6494 25.1882 28.2984L25.1841 28.3018H26.238V26.8018L26.2346 26.8052H27.2851V29.3523L27.2865 29.3482Z",
    fill: "#565ADD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2381 25.7554V24.7124H29.3841V25.7554L29.3882 25.7519H26.2346L26.2381 25.7554Z",
    fill: "#565ADD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1799 30.407H26.229V31.4451H27.2782V32.4935H25.1834C25.1834 31.7973 25.1834 31.1004 25.1834 30.4028L25.1799 30.407Z",
    fill: "#565ADD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3833 29.3481V30.4014L29.3867 30.398H27.2871V29.3481L27.2837 29.3523H29.3874L29.3833 29.3481Z",
    fill: "#565ADD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1929 20.6413V19.0669H26.2255V20.6378H25.1895L25.1929 20.6413Z",
    fill: "#565ADD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1868 28.2984H24.1363V26.8018L24.1328 26.8059H25.1868L25.1833 26.8024V28.3025L25.1868 28.2984Z",
    fill: "#565ADD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8538 25.7534V26.8066L30.8572 26.8025H29.384L29.3882 26.806C29.3882 26.4549 29.3882 26.1038 29.3882 25.7527L29.384 25.7561H30.8579L30.8538 25.7534Z",
    fill: "#565ADD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.429 31.4575H31.8987V32.4902H30.4331C30.4331 32.146 30.4331 31.8017 30.4331 31.4541L30.429 31.4575Z",
    fill: "#565ADD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1883 21.6829H24.146V20.6399H25.1931L25.1889 20.6365C25.1889 20.9866 25.1874 21.3366 25.1842 21.6863L25.1883 21.6829Z",
    fill: "#565ADD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1853 25.7534H26.2393L26.2358 25.75V26.804L26.2393 26.8005H25.1853L25.1887 26.804V25.7534H25.1853Z",
    fill: "#565ADD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1874 29.3477C25.1874 29.7006 25.186 30.0537 25.1833 30.4071L25.1867 30.403H24.1472V29.3511H25.1916L25.1874 29.3477Z",
    fill: "#565ADD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8593 25.7561V24.7131H31.8989V25.7519H30.8552L30.8593 25.7561Z",
    fill: "#565ADD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3833 30.4016H30.4297C30.4297 30.7561 30.4297 31.1065 30.4297 31.4569L30.4331 31.4528L29.384 31.4472L29.3874 31.4507C29.3874 31.0996 29.3874 30.7483 29.3874 30.3967L29.3833 30.4016Z",
    fill: "#565ADD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3911 31.448V32.4909H28.3516V31.4521H29.3952L29.3911 31.448Z",
    fill: "#565ADD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3093 21.9381V20.9055H21.3419V21.9381H20.3093Z",
    fill: "#565ADD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0273 21.9381V20.9055H30.06V21.9381H29.0273Z",
    fill: "#565ADD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3483 29.6201V30.6527H20.3157V29.6201H21.3483Z",
    fill: "#565ADD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3911 26.801V27.844H28.3516V26.8051H29.3952L29.3911 26.801Z",
    fill: "#565ADD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0186 11.6947C26.7524 11.6947 27.4856 11.6947 28.2215 11.6947C28.5802 11.6947 28.7949 11.8792 28.7874 12.1684C28.7805 12.4437 28.5726 12.6192 28.2284 12.6199C26.7515 12.6199 25.2749 12.6199 23.7985 12.6199C23.4384 12.6199 23.2257 12.4368 23.2326 12.1463C23.2395 11.8558 23.4446 11.6961 23.7916 11.6947C24.5323 11.6933 25.2758 11.6947 26.0186 11.6947Z",
    fill: "#2B1C50"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.1106 8.91486C25.5353 8.91486 25.9601 8.91486 26.3841 8.91486C26.7242 8.91486 26.9349 9.0966 26.9349 9.37747C26.9349 9.65835 26.7283 9.83872 26.3841 9.83941C25.5154 9.84262 24.6468 9.84262 23.7785 9.83941C23.4343 9.83941 23.2278 9.65767 23.2278 9.3768C23.2278 9.09593 23.4343 8.91762 23.7785 8.91486C24.2225 8.90867 24.6666 8.91486 25.1106 8.91486Z",
    fill: "#2B1C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundbox);
export default __webpack_public_path__ + "static/media/soundbox.4a3a717fabb7ac113e7e1ef754d91e71.svg";
export { ForwardRef as ReactComponent };